import { render, staticRenderFns } from "./feeding-assistance-section.vue?vue&type=template&id=aa3b2b26"
import script from "./feeding-assistance-section.vue?vue&type=script&lang=js"
export * from "./feeding-assistance-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports